import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Droplet } from 'lucide-react';
export function ProductReveal() {
  return <section className="py-8 md:py-10 px-4 bg-slate-950 relative overflow-hidden" data-id="element-265">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-266" />

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-267">
        <FadeIn data-id="element-268">
          <Droplet className="w-12 h-12 text-orange-500 mx-auto mb-4" strokeWidth={1.5} data-id="element-269" />
          <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-3 tracking-tight" data-id="element-270">
            SISTEMA HUMEDAD CERO
          </h2>
          <p className="text-2xl md:text-3xl text-orange-500 font-serif italic mb-2" data-id="element-271">
            El Método de los 4 Módulos
          </p>
          <p className="text-lg text-slate-400" data-id="element-272">
            4 Módulos + 3 Bonos — Para propietarios argentinos
          </p>
        </FadeIn>
      </div>
    </section>;
}